import { render, staticRenderFns } from "./phoneNumber.vue?vue&type=template&id=208fa726"
import script from "./phoneNumber.vue?vue&type=script&lang=js"
export * from "./phoneNumber.vue?vue&type=script&lang=js"
import style0 from "./phoneNumber.vue?vue&type=style&index=0&id=208fa726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports